import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import React from "react";

const RadioButtonComponent = ({
  value,
  name,
  radiolabel,
  radioListStyle,
  menuItems = [],
  direction = "column",
  ...props
}) => {
  return (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">{radiolabel}</FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue=""
        name={name}
        value={value}
        {...props}
      >
        <Stack direction={direction} justifyContent="center">
          {menuItems?.map((item) => (
            <FormControlLabel
              key={item?.name || item}
              value={item?.value || item}
              control={<Radio />}
              label={item?.name || item}
              sx={radioListStyle}
            />
          ))}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButtonComponent;
